import React from "react";
import { Button } from "./styles";

export function CTAButton(props) {
  const {
    mode,
    mealSettings,
    overallSelected,
    overallLimitations,
    handleCTAClick,
    loading,
    soldOuts,
    selectedBreakfasts,
    breakfastsLimitation,
    selectedEntrees,
    entreesLimitation,
    itemsInCart,
  } = props;

  const CTAButtonText = () => {
    if (mode === "account") {
      return mealSettings.addIns ? "Next" : "Save";
    } else {
      return "Next";
    }
  };

  const disabledButton = () => {
    return (
      <Button disabled>
        <span></span>
        <b>{CTAButtonText()}</b>
      </Button>
    );
  };
  const buttonLimitedMakup = () => {
    if (soldOuts) {
      return disabledButton();
    } else if (selectedBreakfasts >= breakfastsLimitation && selectedEntrees >= entreesLimitation && itemsInCart > 0) {
      return (
        <Button onClick={handleCTAClick} className={loading ? "loading" : ""} disabled={loading ? true : false}>
          <span></span>
          <b>{CTAButtonText()}</b>
        </Button>
      );
    } else {
      return disabledButton();
    }
  };
  const buttonUnlimitedMakup = () => {
    const minPurchaseAmount = localStorage.getItem('minPurchase');
    if (overallSelected >= minPurchaseAmount) {
      return (
        <Button onClick={handleCTAClick} className={loading ? "loading" : ""} disabled={loading ? true : false}>
          <span></span>
          <b>{CTAButtonText()}</b>
        </Button>
      );
    } else {
      return disabledButton();
    }
  };

  return (
    <>
      {overallLimitations === 0 && buttonUnlimitedMakup()}
      {overallLimitations !== 0 && buttonLimitedMakup()}
    </>
  );
}
